import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-otp-enable-warning',
  templateUrl: './otp-enable-warning.component.html',
  styleUrls: ['./otp-enable-warning.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, TranslateModule],
})
export class OtpEnableWarningComponent {
  @Output() closed = new EventEmitter<void>();

  onClose() {
    this.closed.emit();
  }
}
